import "./sandboxStore.css";
import { dealProducts, type PurchaseService, type Store } from "@highmarch/app";
import type { BalanceData } from "@highmarch/domain";
import { btnHtml, closeBtnHtml, ribbonHtml } from "./kit";

/**
 * More → "Debug: Deals — grant offer…" (debug builds with the sandbox store only; docs/SHOP.md §5.1): every Deals
 * product with a GRANT button that buys it through the sandbox store and hands the transaction to PurchaseService, so
 * it is granted exactly as a real one is (Deals.grant: no intent, so the cheapest picks and prize, gear slot 0; VIP
 * points; the purchase limits count). Nothing is ever charged. The store is passed in (Presentation never imports
 * Infrastructure).
 */
export interface DealsDebugDeps {
  readonly balance: BalanceData;
  readonly store: Store;
  readonly purchases: PurchaseService;
  /** Saves and redraws the hub after a grant. */
  changed(): void;
}

export function showDealsDebug(parent: HTMLElement, d: DealsDebugDeps): HTMLElement {
  const sheet = document.createElement("div");
  sheet.className = "sheet panel sandboxstore";
  const products = [...dealProducts(d.balance)];
  let last = "Tap GRANT: the sandbox store sells it, the game grants it.";
  const render = () => {
    sheet.innerHTML = `${ribbonHtml("DEALS: GRANT", "blue", "stitle")}${closeBtnHtml()}
      <div class="sbody">
        <p class="note">${last}</p>
        ${products.map(([id, p]) => `<div class="line"><span>${p.name} · ${p.offerId} · ${p.price.label}</span>${btnHtml("GRANT", "gold", { className: "grant", data: `data-id="${id}"` })}</div>`).join("")}
      </div>`;
    sheet.querySelector<HTMLButtonElement>(".close")!.onclick = () => sheet.remove();
    for (const b of sheet.querySelectorAll<HTMLButtonElement>(".grant")) b.onclick = async () => {
      const id = b.dataset.id ?? "";
      const r = await d.store.purchase(id);
      if (r.status !== "purchased") { last = `${id}: ${r.status}${r.status === "failed" ? ` (${r.reason})` : ""}`; render(); return; }
      const out = await d.purchases.handle(r.transaction);
      const g = d.purchases.dealGrant(r.transaction.transactionId);
      last = `${id}: ${out}${g ? ` · +${g.granted.gems} gems, +${g.vipPoints} VIP, ${g.granted.chests.length} chests, ${g.bankedGear.length + g.granted.gear.length} gear` : ""}`;
      d.changed();
      render();
    };
  };
  render();
  parent.append(sheet);
  return sheet;
}
